export default class Configs {

	static createEditorConfig(height: number) {
		return {
			toolbarGroups: [
				{name: 'document', groups: ['mode', 'document', 'doctools']},
				{name: 'clipboard', groups: ['clipboard', 'undo']},
				{name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
				{name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
			],
			removeButtons: 'Source,Save,Replace,SelectAll,Scayt,About,Maximize,TextColor,Styles,BGColor,ShowBlocks,Format,Font,FontSize,Iframe,PageBreak,SpecialChar,Smiley,HorizontalRule,Table,Flash,Image,Link,Unlink,Anchor,Language,BidiRtl,BidiLtr,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,CreateDiv,Blockquote,Outdent,Indent,RemoveFormat,CopyFormatting,Superscript,Subscript,Strike,Underline,Find,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Templates,Print,Preview,NewPage,PasteText,PasteFromWord',
			height: height
		}
	}
}
